import { serviceCollectionsQuery } from './serviceCollectionsQuery';
import { useQueryRefresh, removeConnectionsMemoized } from 'shared/apollo';

export function useServiceCollectionsQuery() {
  const { data: query, refresh, isLoading } = useQueryRefresh(serviceCollectionsQuery);
  const data = removeConnectionsMemoized(query?.allServiceCollections);

  return { data, refresh, isLoading };
}

